module.exports = __webpack_public_path__ + "img/icon-export.bc261c4b.svg";